import {FLAG_COLORS, type FlagColor} from '@/api/flags';

// Every flag value a filter understands: the eight colours, plus 'any' for "flagged at all".
export type FlagFilter = FlagColor | 'any';

export const isFlagFilter = (value: string): value is FlagFilter =>
  value === 'any' || (FLAG_COLORS as readonly string[]).includes(value);

const FLAG_FILTER_ORDER: readonly FlagFilter[] = ['any', ...FLAG_COLORS];

// 'any' and specific colours are alternatives: picking one clears the other. Colours combine freely.
// The result is always in menu order (any, then FLAG_COLORS) so the URL is stable.
export function toggleFlagFilter(current: readonly FlagFilter[], value: FlagFilter): FlagFilter[] {
  const next = current.includes(value)
    ? current.filter((f) => f !== value)
    : value === 'any'
      ? ['any' as const]
      : [...current.filter((f) => f !== 'any'), value];
  return FLAG_FILTER_ORDER.filter((f) => next.includes(f));
}

// Whether an item survives the filter: no filter keeps everything, 'any' keeps anything flagged,
// colours keep items flagged in one of them. For views whose items are filtered client-side.
export function matchesFlagFilter(
  flag: FlagColor | null | undefined,
  filter: readonly FlagFilter[]
): boolean {
  if (filter.length === 0) {
    return true;
  }

  if (!flag) {
    return false;
  }

  return filter.includes('any') || filter.includes(flag);
}
